import { render, staticRenderFns } from "./Persona_cargaMasiva.vue?vue&type=template&id=a4ff4b82&scoped=true"
import script from "./Persona_cargaMasiva.vue?vue&type=script&lang=js"
export * from "./Persona_cargaMasiva.vue?vue&type=script&lang=js"
import style0 from "./Persona_cargaMasiva.vue?vue&type=style&index=0&id=a4ff4b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ff4b82",
  null
  
)

export default component.exports